import React from 'react';
import { StaticPage, TopbarContainer } from '..';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  DeafPageContent,
} from '../../components';

import css from './DeafPage.module.css';

const DeafPage = () => {
  return (
    <StaticPage
      className={css.root}
      title="Deaf Customers Landing Page"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: 'Deaf Customers Landing Page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <DeafPageContent />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default DeafPage;
